import React from 'react';
import styled, { css } from 'styled-components';
import { withRouter } from 'react-router';
import Arrow from '@catalogo/ui-americanas-desktop-svg/arrow.svg';
import { fmtProps } from '../helpers/store-card';

export const StoreCard = props => {
  const { name, address, openModal, isMobile } = fmtProps(props);

  const DesktopComponent = (
    <>
      <StoreName>{name}</StoreName>
      <StoreAddress>{address}</StoreAddress>
      <BtnSeeMoreStoreDesktop onClick={openModal}>ver mais lojas</BtnSeeMoreStoreDesktop>
    </>
  );

  const MobileComponent = (
    <BtnSeeMoreStoreMobile onClick={openModal}>
      <div>
        <StoreName>{name}</StoreName>
        <StoreAddress>{address}</StoreAddress>
      </div>
      <ArrowIcon />
    </BtnSeeMoreStoreMobile>
  );

  return (
    <Container>
      <TextMessage>Americanas perto de você</TextMessage>
      <BoxStoreCard isMobile={isMobile}>{isMobile ? MobileComponent : DesktopComponent}</BoxStoreCard>
    </Container>
  );
};

const overflowText = css`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Container = styled.div`
  width: 100%;
  font-size: 12px;
  margin-top: 10px;
  font-family: ${({ theme }) => theme.fontFamily};
`;

const TextMessage = styled.p`
  margin-left: 8px;
  color: ${({ theme }) => theme.grey.medium};
`;

const BoxStoreCard = styled.div`
  margin-top: 3px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.grey.light};
  padding: ${({ isMobile }) => (isMobile ? '0px' : '12px 16px')};
`;

const StoreName = styled.p`
  font-size: 14px;
  font-weight: bold;
  ${overflowText}
`;

const StoreAddress = styled.p`
  margin-top: 4px;
  color: ${({ theme }) => theme.grey.medium};
  ${overflowText}
`;

const BtnSeeMoreStoreDesktop = styled.a`
  cursor: pointer;
  font-size: 14px;
  margin-top: 7px;
  display: inline-block;
  text-decoration: underline;
  color: ${({ theme }) => theme.grey.dark};

  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const BtnSeeMoreStoreMobile = styled.a`
  display: flex;
  font-size: 14px;
  border-radius: 8px;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
`;

const ArrowIcon = styled(Arrow)`
  width: 12px;
  height: 12px;
  transform: rotate(-90deg);
`;

export default withRouter(StoreCard);
